import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, debounceTime, distinctUntilChanged, filter, map, switchMap, takeUntil } from 'rxjs';
import { PropertyItemBulkActionEnum } from '../../Models/Interfaces/PropertyItemBulkActionEnum';
import { BaseEditPopUpComponent } from '../../Services/BaseEditPopUpComponent';
import { ConfigService } from "../../Services/ConfigService";
import { CustomerAccountService } from "../../Services/Custom/ServiceCustomerAccount";
import { PropertyItemService } from '../../Services/Custom/ServicePropertyItem';
import { SearchService } from '../../Services/Custom/ServiceSearch';
import { TypeStorageFeeService } from '../../Services/Custom/ServiceTypeStorageFee';

@Component({
	selector: 'PropertyItemBulk',
	templateUrl: 'PropertyItemBulk.html',
	
})
export class PropertyItemBulkComponent extends BaseEditPopUpComponent implements OnInit {
	ngOnInit(): void {
		if (this.myItem.Action == PropertyItemBulkActionEnum.AddFee && !this.configData.IsEmptyGuid(this.customerAccountID)) {
			this.myCustomerAccountService.getOverallSettings(this.customerAccountID, false, false)
				.pipe(takeUntil(this.obsToCloseSubject))
				.subscribe(settings => {
					this.accountFees = settings.CustomerTypeStorageFeeCol;
					if (this.myItem.InvoiceAmount == null) {
						this.changeFee();
					}
				});
		}
	}

	constructor(
		public configData: ConfigService,
		private myPropertyItemService: PropertyItemService,
		private myTypeStorageFeeService: TypeStorageFeeService,
		private myCustomerAccountService: CustomerAccountService,
		private mySearchService: SearchService,
		protected myActiveModal: NgbActiveModal,
	) {
		super();
		this.activeModal = myActiveModal;
	}
	feeTypes: TooBig4Car.Logic.TypeStorageFee[] = [];
	accountFees: TooBig4Car.Logic.CustomerTypeStorageFeeVM[] = null;
	bulkChoices = PropertyItemBulkActionEnum.getChoices();
	get bulkName(): string {
		return this.bulkChoices.filter(a => a.Value == this.myItem.Action)[0].Text;
	}
	myItem = {
		Action: PropertyItemBulkActionEnum.AddFee
	} as TooBig4Car.Logic.PropertyItemBulkActionVM;

	setItem(obj: TooBig4Car.Logic.PropertyItemBulkActionVM) {
		this.myItem = obj;
		if (this.myItem.Action == PropertyItemBulkActionEnum.AddFee) {
			this.myTypeStorageFeeService.loadAll(true)
				.pipe(takeUntil(this.obsToCloseSubject))
				.subscribe(col => {
					this.feeTypes = col;
				});
		}
	}
	customerAccountID: System.Guid;

	changeFee() {
		if (this.accountFees) {
			var fee = this.accountFees.filter(a => a.TypeStorageFeeID == this.myItem.TypeStorageFeeID);
			this.myItem.InvoiceAmount = fee.length ? fee[0].Rate : null;
		}
	}

	sidemarkFormatter = (value: TooBig4Car.Logic.SearchResultBase) => value.SearchName;

	searchSidemark = (text$: Observable<string>) =>
		text$.pipe(
			filter(term => term != '' && term.length > 1 && !this.configData.IsEmptyGuid(this.customerAccountID)),
			map(a => a.trim()),
			debounceTime(400),
			distinctUntilChanged(),
			switchMap((term: string) => this.mySearchService.searchSidemarks({
				CustomerAccountID: this.customerAccountID,
				SearchText: term,
				Include: true
			}))
		);

	onSelectSidemark($event: any) {
		$event.preventDefault();
		this.myItem.Sidemark = $event.item.SearchName;
	}

	saveItem(form: NgForm) {
		var clearing = '';
		if (this.myItem.Action == PropertyItemBulkActionEnum.ChangeSidemark && !this.myItem.Sidemark) {
			clearing = 'Sidemark';
		} else if (this.myItem.Action == PropertyItemBulkActionEnum.ChangeDestinationRoom && !this.myItem.DestinationRoom) {
			clearing = 'Destination Room';
		}
		if (clearing) {
			this.dialogService.confirm(`Are you sure you want to clear the ${clearing} on the selected pieces?`).then(cfm => {
				if (cfm) {
					this.saveItemInner(form);
				}
			});
		} else {
			this.saveItemInner(form);
		}
	}

	saveItemInner(form: NgForm) {
		this.isSaving = true;
		this.myPropertyItemService.bulkAction(this.myItem)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe((obj) => {
				this.closePopUp(obj);
			},
				(error: any) => {
					this.showValidationErrors(error, form);
				});
	}
}
